export const CONTROL_PANEL_SIDEBAR_OPEN_UPDATE = "CONTROL_PANEL_SIDEBAR_OPEN_UPDATE"
export const CONTROL_PANEL_SIDEBAR_CLOSE = "CONTROL_PANEL_SIDEBAR_CLOSE"
export const CONTROL_PANEL_SIDEBAR_OPEN = "CONTROL_PANEL_SIDEBAR_OPEN"
